import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import "../../assets/style/TaxHeadForm.css"; 
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FiPlus, FiTrash2, FiSave, FiX } from "react-icons/fi";

const TaxHeadForm = ({
  onClose,
  fetchData,
  taxheadSingleData,
  isAddData,
  tableData,
  rowId,
}) => {
  const [singleData, setSingleData] = useState(taxheadSingleData);
  const [businessTypeData, setBusinessTypeData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  console.log("singleData",singleData)

  const validationSchema = Yup.object({
    business_type: Yup.string().required("Please select business type"),
    template_field: isAddData
      ? Yup.string().required("Template Field Required")
      : Yup.string(),
    types: Yup.array()
      .of(
        Yup.object().shape({
          type: Yup.string().required("Please select tax type"),
          tax_head_name: Yup.string().required("Tax head name is required"),
        })
      )
      .required("Must have at least one tax head"),
    additionalType: Yup.array()
      .of(
        Yup.object().shape({
          type: Yup.string().required("Please select tax type"),
          additional_tax: Yup.string().required("Additional Tax is required"),
          arithmetic: Yup.string().required("Arithmetic is required"),
        })
      )
      .required("Must have at least one tax head"),
  });

  const id = taxheadSingleData && taxheadSingleData?.id;

  useEffect(() => {
    const typeData = tableData?.map((item) => {
      return { label: item.business_type, value: item.business_type };
    });
    setBusinessTypeData(typeData);
  }, [tableData]);

  const navigate = useNavigate();
  const lastFieldRef = useRef(null);
  const formContainerRef = useRef(null);

  const taxTypeData = [
    { label: "High", value: "High" },
    { label: "Low", value: "Low" },
    { label: "Gas", value: "Gas" },
    { label: "Diesel", value: "Diesel" },
    { label: "Non Taxable", value: "Non Taxable" },
    { label: "Other", value: "Other" },
    { label: "GA Tax", value: "GA Tax" },
    { label: "Hotel Occupancy", value: "Hotel Occupancy" },
    { label: "Room Tax", value: "Room Tax" },
    { label: "Adjustment", value: "Adjustment" },
    { label: "Custom", value: "Custom" },
    { label: "Non Food", value: "Non Food" },
    { label: "Food Sales", value: "Food Sales" },
    { label: "CBD Sales", value: "CBD Sales" },
    { label: "Non Taxable Sales", value: "Non Taxable Sales" },
    { label: "Lotto & Non Sales", value: "Lotto & Non Sales" },
    { label: "Other Misc Info", value: "Other Misc Info" },
  ];

  const handleSubmit = async (values) => {
    try {
      setIsSubmitting(true);
      const request_url = isAddData
        ? "/api/create-tax-head"
        : id
        ? `/api/update-tax-head/${id}`
        : "/api/create-tax-head";
      const postDataResult = await postData(request_url, values);
      toast.success(
        postDataResult?.message || "Operation completed successfully"
      );
      setIsSubmitting(false);
      if (fetchData) fetchData();
      onClose();
    } catch (error) {
      setIsSubmitting(false);
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  const scrollToBottom = () => {
    const targetSection = document.getElementById("target-section123");
    if (targetSection) {
      targetSection.scrollTo({
        top: targetSection.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    // Add a nice fade-in effect when the form loads
    if (formContainerRef.current) {
      formContainerRef.current.style.opacity = 0;
      setTimeout(() => {
        if (formContainerRef.current) {
          formContainerRef.current.style.transition = "opacity 0.5s ease";
          formContainerRef.current.style.opacity = 1;
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <div ref={formContainerRef}>
        <Formik
          enableReinitialize
          initialValues={{
            business_type: taxheadSingleData ? singleData?.business_type : "",
            template_field: "",
            types: taxheadSingleData
              ? singleData?.types
              : [{ type: "", tax_head_name: "", id: null }],
            additionalType: taxheadSingleData ? singleData?.tax_head_rules : [],
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {({ errors, touched, values, handleChange, setFieldValue }) => (
            <Form>
              <div className="form-container">
                <div className="form-row">
                  {rowId ? (
                    <>
                      <div className="form-col-12">
                        <label htmlFor="business_type" className="form-label">
                          Business Type
                          <span className="valid-msg">*</span>
                        </label>
                        {isAddData ? (
                          <>
                            <Field
                              name="business_type"
                              component={CustomSelect}
                              options={businessTypeData}
                              menuPosition="none"
                              onChange={(e) => {
                                setFieldValue("business_type", e.value);
                                const SelectedData = tableData?.find(
                                  (item) => item?.business_type === e.value
                                );
                                setSingleData(SelectedData);
                              }}
                              placeholder="Select a business type"
                            />
                            {errors.business_type && touched.business_type && (
                              <div className="error-msg">
                                {errors.business_type}
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            <Field
                              disabled={true}
                              id="business_type"
                              name="business_type"
                              className="form-control"
                              type="text"
                              placeholder="business_type"
                            />
                          </>
                        )}
                      </div>
                        {isAddData && (
                      <div className="form-col-12">
                          <>
                            <label className="form-label">
                              Template Field Name
                              <span className="valid-msg">*</span>
                            </label>
                            <Field
                              id="template_field"
                              name="template_field"
                              className="form-control"
                              type="text"
                              placeholder="Please enter Template Field"
                            />
                            {errors.template_field &&
                              touched.template_field && (
                                <div className="error-msg">
                                  {errors.template_field}
                                </div>
                              )}
                          </>
                      </div>
                        )}
                    </>
                  ) : (
                    <>
                      <div className="form-col-12">
                        <label htmlFor="business_type" className="form-label">
                          Business Type
                          <span className="valid-msg">*</span>
                        </label>
                        <Field
                          id="business_type"
                          name="business_type"
                          className="form-control"
                          type="text"
                          placeholder="Please enter Business Type"
                          onChange={(e) => {
                            setFieldValue("business_type", e.target.value);
                            setFieldValue("template_field", e.target.value);
                          }}
                        />
                        {errors.business_type && touched.business_type && (
                          <div className="error-msg">
                            {errors.business_type}
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  <div
                    className="form-col-12"
                    style={{
                      marginTop: "10px",
                      minHeight: "auto",
                      maxHeight: "40vh",
                      overflow: "auto",
                      zIndex: 1,
                    }}
                    id="target-section123"
                  >
                    <div className="form-col-12 tax-section">
                      <h4>Tax Heads</h4>
                      <FieldArray name="types">
                        {({ push, remove }) => (
                          <React.Fragment>
                            {values?.types?.map((_, index) => (
                              <div className="form-row" key={index}>
                                <div className="form-col-5-half">
                                  <label className="form-label">
                                    Tax Head Name
                                    <span className="valid-msg">*</span>
                                  </label>
                                  <Field
                                    id={`types.${index}.tax_head_name`}
                                    name={`types.${index}.tax_head_name`}
                                    className="form-control"
                                    type="text"
                                    placeholder="Please enter tax head name"
                                    innerRef={
                                      index === values.types.length - 1
                                        ? lastFieldRef
                                        : null
                                    }
                                  />
                                  {errors.types &&
                                    errors.types[index] &&
                                    errors.types[index].tax_head_name &&
                                    touched.types &&
                                    touched.types[index] &&
                                    touched.types[index].tax_head_name && (
                                      <div className="error-msg">
                                        {errors.types[index].tax_head_name}
                                      </div>
                                    )}
                                </div>
                                <div className="form-col-5">
                                  <label className="form-label">
                                    Select Tax Type
                                    <span className="valid-msg">*</span>
                                  </label>
                                  <Field
                                    name={`types.${index}.type`}
                                    component={CustomSelect}
                                    options={taxTypeData}
                                    menuPosition="fixed"
                                    menuPortalTarget={document?.body}
                                    placeholder="Select tax type"
                                  />
                                  {errors.types &&
                                    errors.types[index] &&
                                    errors.types[index].type &&
                                    touched.types &&
                                    touched.types[index] &&
                                    touched.types[index].type && (
                                      <div className="error-msg">
                                        {errors.types[index].type}
                                      </div>
                                    )}
                                </div>
                                <div
                                  className="form-col-1-half"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      paddingTop: "20px",
                                    }}
                                  >
                                    <div>
                                      <button
                                        type="button"
                                        className={`icon-button ${
                                          index === 0 ? "disabled" : "remove"
                                        }`}
                                        onClick={() =>
                                          index !== 0 && remove(index)
                                        }
                                        disabled={index === 0}
                                        title={
                                          index === 0
                                            ? "Cannot remove first tax head"
                                            : "Remove this tax head"
                                        }
                                      >
                                        <FiTrash2 size={18} />
                                      </button>
                                    </div>

                                    {index === values.types.length - 1 && (
                                      <div>
                                        <button
                                          type="button"
                                          className="icon-button add"
                                          onClick={() => {
                                            push({
                                              type: "",
                                              tax_head_name: "",
                                              id: null,
                                            });
                                            setTimeout(scrollToBottom, 100);
                                          }}
                                          title="Add new tax head"
                                        >
                                          <FiPlus size={18} />
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </React.Fragment>
                        )}
                      </FieldArray>
                    </div>

                    <div className="form-col-12 tax-section">
                      <FieldArray name="additionalType">
                        {({ push, remove }) => (
                          <React.Fragment>
                            <>
                              <div className="section-header">
                                <h4>Local / Education Tax Formula</h4>
                                <button
                                  type="button"
                                  className="icon-button add"
                                  onClick={() => {
                                    push({
                                      type: "",
                                      additional_tax: "",
                                      arithmetic: "",
                                      id: null,
                                    });
                                    setTimeout(scrollToBottom, 100);
                                  }}
                                  title="Add new formula"
                                >
                                  <FiPlus size={18} />
                                </button>
                              </div>
                              {values?.additionalType?.map((_, index) => {
                                const selectedTypes = values?.additionalType
                                  ?.map((item) => item.type)
                                  .filter(Boolean);

                                const typeData = values?.types
                                  ?.map((int) => ({
                                    label: int.type,
                                    value: int.type,
                                  }))
                                  ?.filter(
                                    (obj, idx, self) =>
                                      idx ===
                                      self.findIndex(
                                        (t) => t.value === obj.value
                                      )
                                  );

                                const availableOptions = typeData.filter(
                                  (option) =>
                                    !selectedTypes?.includes(option.value) ||
                                    option.value ===
                                      values.additionalType[index]?.type
                                );

                                return (
                                  <div className="form-row" key={index}>
                                    <div className="form-col-3-half">
                                      <label className="form-label">
                                        Tax
                                        <span className="valid-msg">*</span>
                                      </label>
                                      <Field
                                        name={`additionalType.${index}.additional_tax`}
                                        component={CustomSelect}
                                        options={[
                                          {
                                            label: "Education Tax",
                                            value: "Education_Tax",
                                          },
                                          {
                                            label: "Local Tax 1",
                                            value: "Local_Tax_1",
                                          },
                                        ]}
                                        menuPosition="fixed"
                                        menuPortalTarget={document?.body}
                                        disabled={index !== 0}
                                        onChange={(selectedOption) => {
                                          const newValues =
                                            values.additionalType.map(
                                              (item, idx) => ({
                                                ...item,
                                                additional_tax:
                                                  index === 0 || idx === 0
                                                    ? selectedOption?.value
                                                    : values.additionalType[idx]
                                                        .additional_tax,
                                              })
                                            );
                                          setFieldValue(
                                            "additionalType",
                                            newValues
                                          );
                                        }}
                                        placeholder="Select tax"
                                      />
                                      {errors.additionalType &&
                                        errors.additionalType[index] &&
                                        errors.additionalType[index]
                                          .additional_tax &&
                                        touched.additionalType &&
                                        touched.additionalType[index] &&
                                        touched.additionalType[index]
                                          .additional_tax && (
                                          <div className="error-msg">
                                            {
                                              errors.additionalType[index]
                                                .additional_tax
                                            }
                                          </div>
                                        )}
                                    </div>
                                    <div className="form-col-3-half">
                                      <label className="form-label">
                                        Tax Type
                                        <span className="valid-msg">*</span>
                                      </label>
                                      <Field
                                        name={`additionalType.${index}.type`}
                                        component={CustomSelect}
                                        options={availableOptions}
                                        menuPosition="fixed"
                                        menuPortalTarget={document?.body}
                                        placeholder="Select tax type"
                                      />
                                      {errors.additionalType &&
                                        errors.additionalType[index] &&
                                        errors.additionalType[index].type &&
                                        touched.additionalType &&
                                        touched.additionalType[index] &&
                                        touched.additionalType[index].type && (
                                          <div className="error-msg">
                                            {errors.additionalType[index].type}
                                          </div>
                                        )}
                                    </div>
                                    <div className="form-col-3-half">
                                      <label className="form-label">
                                        Computation
                                        <span className="valid-msg">*</span>
                                      </label>
                                      <Field
                                        name={`additionalType.${index}.arithmetic`}
                                        component={CustomSelect}
                                        options={[
                                          { label: "Addition (+)", value: "+" },
                                          {
                                            label: "Subtraction (-)",
                                            value: "-",
                                          },
                                          {
                                            label: "Multiplication (×)",
                                            value: "*",
                                          },
                                          { label: "Division (÷)", value: "/" },
                                        ]}
                                        menuPosition="fixed"
                                        menuPortalTarget={document?.body}
                                        placeholder="Select computation"
                                      />
                                      {errors.additionalType &&
                                        errors.additionalType[index] &&
                                        errors.additionalType[index]
                                          .arithmetic &&
                                        touched.additionalType &&
                                        touched.additionalType[index] &&
                                        touched.additionalType[index]
                                          .arithmetic && (
                                          <div className="error-msg">
                                            {
                                              errors.additionalType[index]
                                                .arithmetic
                                            }
                                          </div>
                                        )}
                                    </div>
                                    <div
                                      className="form-col-1-half"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          paddingTop: "20px",
                                        }}
                                      >
                                        <div>
                                          <button
                                            type="button"
                                            className="icon-button remove"
                                            onClick={() => remove(index)}
                                          >
                                            <FiTrash2 size={18} />
                                          </button>
                                        </div>

                                        {index ===
                                          values.additionalType.length - 1 && (
                                          <div>
                                            <button
                                              type="button"
                                              className="icon-button add"
                                              onClick={() => {
                                                push({
                                                  type: "",
                                                  additional_tax:
                                                    values.additionalType[0]
                                                      ?.additional_tax || "",
                                                  arithmetic: "",
                                                  id: null,
                                                });
                                                setTimeout(() => {
                                                  const targetSection =
                                                    document.getElementById(
                                                      "target-section123"
                                                    );
                                                  targetSection?.scrollTo({
                                                    top: targetSection.scrollHeight,
                                                    behavior: "smooth",
                                                  });
                                                }, 100);
                                              }}
                                            >
                                              <FiPlus size={18} />
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          </React.Fragment>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                </div>
              </div>
          
            <div className="form-footer">
              <button
                type="button"
                className="btn btn-cancel"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                Submit
              </button>
            </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default TaxHeadForm;
